<script lang="ts">
	export let heightPx = 3;

	let value: number;
	function scroll() {
		value = window.scrollY / (document.body.offsetHeight - window.innerHeight);
	}
</script>

<svelte:window on:scroll={scroll} />

<div class="{$$props.class ?? 'sticky top-0'}">
	<div class="w-full relative">
		<div class="absolute inset-0 bg-neutral" style="height: {heightPx}px;" />
		<div
			class="absolute inset-0 bg-primary progress "
			style="height: {heightPx}px; --scroll: {value};"
		/>
	</div>
</div>

<style>
	/** Reference <https://css-tricks.com/books/greatest-css-tricks/scroll-animation/> */
	.progress {
		width: 0%;
		animation: progress 1s linear;
		/* Pause the animation */
		animation-play-state: paused;
		/* Bind the animation to scroll */
		animation-delay: calc(var(--scroll) * -1s);
		/* These last 2 properites clean up overshoot weirdness */
		animation-iteration-count: 1;
		animation-fill-mode: both;
	}

	@keyframes progress {
		to {
			width: 100%;
		}
	}
</style>
